<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="boolean" :variableData="variableDataComponent">
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div
                  class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6  mt-2"
                >
                  <InputSelect
                    id="defaultValue"
                    validate="required"
                    name="defaultValue"
                    label="Valor por Defecto"
                    :options="defaultValue_options"
                    placeholder="Seleccione un valor por defecto"
                    :value.sync="variableDataComponent.config.defaultValue"
                  />
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
      </template>
    </generalForm>
  </div>
</template>

<script>
import generalForm from '@/src/components/variables/general-form'
import InputSelect from '@components/form/InputSelect'

export default {
  name: 'booleanComponent',
  components: {
    generalForm,
    InputSelect,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      defaultConfig: {
        defaultValue: null,
      },
      defaultValue_options: [
        { value: 0, text: 'Falso' },
        { value: 1, text: 'Verdadero' },
      ],
    }
  },
  mounted() {
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
  },
}
</script>
